/**
 * User-code handling for the device pairing approval page (WEB-7089).
 *
 * The same code reaches us in more than one shape. The QR encodes it ungrouped
 * (`...?code=K7QP3MRX`), the car's screen shows it grouped (`K7QP-3MRX`), and anyone
 * hand-typing the URL may copy what is on the screen, in either case. The API normalises too,
 * but doing it here as well keeps what we display consistent with what we send, and keeps the
 * rules in one testable place rather than inline in a component.
 *
 * The alphabet the API issues from is A-Z and 2-9 less O, 0, I, 1, L and U, so there is no
 * lowercase and no ambiguous glyph to map - uppercasing is enough.
 */

/** Strips grouping and whitespace and uppercases. Returns '' for anything missing. */
export const normaliseCode = raw =>
  (raw || '').trim().replace(/[-\s]/g, '').toUpperCase()

/**
 * Groups a code in the middle for display: K7QP3MRX -> K7QP-3MRX.
 *
 * Grouping matches what the head unit shows, so the two can be compared at a glance. Codes of
 * four characters or fewer are left alone - a hyphen in a very short code hurts legibility
 * rather than helping it.
 */
export const formatCodeForDisplay = code => {
  const normalised = normaliseCode(code)

  if (normalised.length <= 4) return normalised

  const split = Math.ceil(normalised.length / 2)
  return `${normalised.slice(0, split)}-${normalised.slice(split)}`
}
